import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ContactSection from "../../components/ContactSection";
import { AboutUI, Paragraph, Title } from "../home/sections/About";
import VehicleCard from "../../components/VehicleCard";
import { flota, automaticos, manuales } from "../../data/Data";
import WhatsappBTN from "../../components/WhatsappBTN";
import shortid from "shortid";
import FilterButton from "../../components/FilterButton";

const CarsUI = styled(AboutUI)`
  margin-top: 90px;
  gap: 10px;
`;

const CardsContainer = styled.div`
  display: flex;
  padding: 30px 0px;
  gap: 70px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1500px;
  @media (max-width: 500px) {
    padding: 30px 0px;
  }
`;

const P = styled(Paragraph)`
  text-align: center;

  @media (max-width: 992px) {
    width: 100%;
  }
`;
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  margin: 30px 0px;
  flex-wrap: wrap;
  @media (max-width: 576px) {
    margin: 15px 0px;
    flex-direction: column;
    align-items: center;
  }
`;

const Cars = () => {
  const [cars, setCars] = useState(flota);
  const [todas, setTodas] = useState(true);
  const [manual, setManual] = useState(false);
  const [aut, setAut] = useState(false);

  const changeState = (filtro, str) => {
    setTodas(str === "todas" ? true : false);
    setManual(str === "manual" ? true : false);
    setAut(str === "aut" ? true : false);
    setCars(filtro);
  };

  return (
    <>
      <WhatsappBTN />
      <Header />
      <CarsUI>
        <Title>
          NUESTROS <span>AUTOS</span>
        </Title>
        <P>Elegí el auto que mas te guste y contactanos para reservar</P>
        <ButtonsContainer>
          <FilterButton
            inverted={todas}
            onClick={() => changeState(flota, "todas")}
          >
            Todos
          </FilterButton>
          <FilterButton
            inverted={manual}
            onClick={() => changeState(manuales, "manual")}
          >
            Manuales
          </FilterButton>
          <FilterButton
            inverted={aut}
            onClick={() => changeState(automaticos, "aut")}
          >
            Automaticos
          </FilterButton>
        </ButtonsContainer>
        <CardsContainer>
          {cars.map((car) => (
            <VehicleCard key={shortid.generate()} item={car} />
          ))}
        </CardsContainer>
      </CarsUI>

      <ContactSection />
      <Footer />
    </>
  );
};

export default Cars;
